import { ClockIcon, GroupIcon, LocationIcon, TrophyIcon, LevelIcon, CalendarIcon, EmailIcon, PaymentIcon } from './FormationIcons';

interface FormationBadgesProps {
  duration_hours: number;
  min_participants: number;
  max_participants: number;
  mode: 'presentiel' | 'distanciel' | 'hybride';
  nextSessionDate?: string;
}

export function FormationBadges({
  duration_hours,
  min_participants,
  max_participants,
  mode,
  nextSessionDate,
}: FormationBadgesProps) {
  const modeLabels = {
    presentiel: 'Présentiel',
    distanciel: 'Distanciel',
    hybride: 'Hybride',
  };

  const badges = [
    {
      icon: ClockIcon,
      label: `${duration_hours}h`,
      sublabel: 'Durée',
    },
    {
      icon: GroupIcon,
      label: `${min_participants}-${max_participants}`,
      sublabel: 'Groupe',
    },
    {
      icon: LocationIcon,
      label: modeLabels[mode],
      sublabel: 'Format',
    },
    {
      icon: TrophyIcon,
      label: 'QUALIOPI',
      sublabel: 'Certifié',
    },
    {
      icon: LevelIcon,
      label: 'Intermédiaire',
      sublabel: 'Niveau',
    },
    ...(nextSessionDate
      ? [
          {
            icon: CalendarIcon,
            label: new Date(nextSessionDate).toLocaleDateString('fr-FR', {
              day: 'numeric',
              month: 'short',
            }),
            sublabel: 'Prochaine',
          },
        ]
      : []),
    {
      icon: EmailIcon,
      label: 'Sous 48h',
      sublabel: 'Réponse',
    },
    {
      icon: PaymentIcon,
      label: 'Sécurisé',
      sublabel: 'Paiement',
    },
  ];

  return (
    <section className="py-8 bg-white border-y border-border">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center gap-2 bg-white border-2 border-border rounded-xl px-6 py-4 hover:border-aspexit-red hover:shadow-md transition-all"
            >
              <badge.icon className="w-6 h-6 text-aspexit-red" />
              <div className="text-center">
                <div className="font-semibold text-aspexit-black text-sm">
                  {badge.label}
                </div>
                <div className="text-xs text-aspexit-gray">{badge.sublabel}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
